import styled from "styled-components";
import { motion } from "framer-motion";

export const Features = styled.div`
  h2 {
    font-weight: 600;
    font-size: 20px;
    margin: 0;
    margin-bottom: 15px;
  }
  @media (max-width: 530px) {
    margin-top: 15px;
    text-align: center;
  }
`;
export const FeaturesList = motion(styled.ul`
  @media (max-width: 530px) {
    max-width: 90%;
    margin: 0 auto;
  }
`);
export const Feature = motion(styled.li`
  font-weight: 400;
  margin-bottom: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  div {
    padding-top: 1px;
    height: 18px;
    min-width: 18px;
    width: 18px;
    min-height: 18px;
    background-color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    margin-inline-start: 10px;
  }
  @media (max-width: 530px) {
    justify-content: flex-start;
    //flex-direction: column;
    //justify-content: center;
    margin-bottom: 12px;
    div {
      margin-right: 10px;
    }
    span {
      text-align: left;
      margin-top: 5px;
      margin-left: 0;
    }
  }
`);
